import { Box } from "@mui/material";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import React from "react";
import { CartHeading, cartPanelSx } from "./CartView";
import { C, FONT_BODY, RADIUS, TYPE } from "../../../utils/designTokens";

/** Empty bag: icon, "Your bag is empty", a hint, and a disabled checkout. */
function EmptyView({ flat = false }) {
  return (
    <Box component="section" aria-labelledby="cart-empty-title" sx={cartPanelSx(flat)}>
      <CartHeading id="cart-empty-title" count={0} />
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", py: 4, px: 1 }}>
        <Box
          aria-hidden="true"
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: C.surface2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          <ShoppingBagOutlinedIcon sx={{ fontSize: 30, color: C.ink }} />
        </Box>
        <Box sx={{ ...TYPE.cardTitle, color: C.ink }}>Your bag is empty</Box>
        <Box sx={{ ...TYPE.meta, color: C.muted, mt: 0.5, maxWidth: 260 }}>
          Add dishes from the menu and they'll show up here.
        </Box>
      </Box>
      <Box
        component="button"
        type="button"
        disabled
        sx={{
          width: "100%",
          height: 56,
          border: 0,
          borderRadius: RADIUS.controlLg,
          bgcolor: C.disabledBg,
          color: C.disabledText,
          fontFamily: FONT_BODY,
          fontSize: 16,
          fontWeight: 700,
          cursor: "not-allowed",
        }}
      >
        Go to checkout
      </Box>
    </Box>
  );
}

export default React.memo(EmptyView);
